import React from 'react';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import { RichText } from '@vimily/bonjoro-ui-components-v2/RichTextEditor';
import { RichTextViewer } from '@vimily/bonjoro-ui-components-v2/RichTextViewer';
import { computeTextColor } from '@vimily/bonjoro-ui-components-v2';

export interface TextPreviewMobileProps {
  response?: RichText;
  hideChangeResponseButton?: boolean;
  onEditClick?: () => void;
  onBackClick?: () => void;
  primaryCtaColor?: string;
  secondaryCtaColor?: string;
  ctaCornerRadius?: number;
  fontFamily?: string;
}

/**
 * TODO: Consolidate the correct Rich Text Editor container
 * https://bonjoro.atlassian.net/browse/PLG-301
 */
export default function TextPreviewMobile({
  response = [],
  hideChangeResponseButton = false,
  onEditClick,
  onBackClick,
  primaryCtaColor,
  secondaryCtaColor,
  ctaCornerRadius = 4,
  fontFamily,
}: TextPreviewMobileProps) {
  const editResponseButtonProps = {
    className: 'w-full',
    onClick: onEditClick,
    style: {
      borderRadius: `${ctaCornerRadius}px`,
      borderColor: primaryCtaColor,
      backgroundColor: primaryCtaColor,
      color: computeTextColor(primaryCtaColor),
      fontFamily,
    },
  };

  const changeResponseButtonProps = {
    className: 'w-full',
    onClick: onBackClick,
    style: {
      borderRadius: `${ctaCornerRadius}px`,
      borderColor: secondaryCtaColor,
      backgroundColor: secondaryCtaColor,
      color: computeTextColor(secondaryCtaColor),
      fontFamily,
    },
  };

  return (
    <div className='justify-center w-full flex flex-col px-[15px] max-h-52'>
      <p className='text-sm text-neutral-600 mb-5 whitespace-pre-wrap break-words overflow-y-auto'>
        <RichTextViewer value={response} />
      </p>
      <div className='flex gap-x-3'>
        <Button {...editResponseButtonProps}>Edit response</Button>
        {!hideChangeResponseButton && (
          <Button {...changeResponseButtonProps}>Change response</Button>
        )}
      </div>
    </div>
  );
}
